import { CountryData } from 'data/total-consumption.csv'
import { extractValue } from 'lib/extractValue'
import { bisector } from 'd3-array'

export function getDifference(
  value: number,
  countryData: CountryData,
  accessor: string
) {
  if (!countryData) return Number.POSITIVE_INFINITY

  return Math.abs(extractValue(countryData[accessor]) - value)
}

export function getClosestCountryConsumptionWise(
  userConsumption: number,
  allCountryData: CountryData[],
  isFemale: boolean
) {
  const accessor = isFemale ? 'Female' : 'Male'

  // Sort the country data …
  allCountryData.sort(
    (a, b) => extractValue(a[accessor]) - extractValue(b[accessor])
  )

  /* So, this gives the index of the next *higher* country, using the bisector.
  The bisector gives the index where in a sorted array an object would have to
  be inserted to keep the sorting intact. */
  const index = bisector((d: CountryData) => extractValue(d[accessor])).left(
    allCountryData,
    userConsumption
  )

  // Compare the country before and after this entry point and decided which one is closer
  const upperDifference = getDifference(
    userConsumption,
    allCountryData[index],
    accessor
  )
  const lowerDifference = getDifference(
    userConsumption,
    allCountryData[index - 1],
    accessor
  )
  return upperDifference > lowerDifference
    ? allCountryData[index - 1]
    : allCountryData[index]
}
